import { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Image, Button, Form, FormGroup, FormControl } from "react-bootstrap";
import { MESSAGE } from '../../../utils/message';
import Latest_news_icon from "../../../assests/images/latest-news-icon.svg"
import {
    LatestNewsFormWrapper,
    LatestNewsTitle,
    InputGroup,
    FormInputGroup,
    FormGroupWrapper,
} from "./latestNewsFormStyle";
import { useFormik } from "formik";
import * as Yup from "yup";
import { REGEX } from "../../../utils/constant";
import { useDispatch, useSelector } from "react-redux";
import { subscribeAction, subscribeHandler } from "../../../redux/slices/subscribe/subscribe-slice";
import LatestNewSubmitModal from '../../common/modal/latestNewSubmitModal';
import { LatestNewsFormikProps } from "../../../utils/types";
import ErrorModal from "../modal/errorModal";
import { showErrorToast } from "../../../utils/toast";

const LatestNewsForm = () => {
    const [editLatestNewSubmitOpen, setEditLatestNewSubmitOpen] = useState(false);
    const [loader, setLoader] = useState(false);
    const dispatch: any = useDispatch();
    const subscribe = useSelector((state: any) => state?.subscribe?.data);

    const [errorMsg, setErrorMsg] = useState('');
    const [errorFlag, setErrorFlag] = useState(false);

    const maxLengthCheck = (object: any) => {
        if (object.target.value.length > object.target.max.length) {
            object.target.value = object.target.value.slice(0, object.target.max.length);
        }
    };

    const handleChange = (e: any) => {
        maxLengthCheck(e);
    };

    const formik = useFormik({
        initialValues: {
            email: "",
            zipcode: "",
            type: "",
        },
        validationSchema: Yup.object({
            email: Yup.string().trim().matches(REGEX.emailValidate, {
                message: MESSAGE.invalidErrors(MESSAGE.emailLabel),
                excludeEmptyString: true,
            })
                .max(50, MESSAGE.maxLengthErrors(MESSAGE.emailLabel, 50))
                .required(MESSAGE.requiredErrors(MESSAGE.emailLabel)),
            zipcode: Yup.string()
                .matches(/^\d{5,7}$/, MESSAGE.invalidErrors(MESSAGE.zipCodeLabel)) // 5 to 7 digit zip code
                .required(MESSAGE.requiredErrors(MESSAGE.zipCodeLabel)),
            type: Yup.string().trim().required(MESSAGE.requiredErrors(MESSAGE.individualOrganizationLabel))
        }),
        onSubmit: (values: LatestNewsFormikProps) => {
            dispatch(subscribeHandler(values));
            setLoader(true);
            formik.resetForm({})
        },
    });


    useEffect(() => {
        if (subscribe?.success || subscribe?.status === 200) {
            setEditLatestNewSubmitOpen(true);
            setLoader(false);
            formik.resetForm({})
            dispatch(subscribeAction.subscribeSliceReset());
        } else if (subscribe?.data?.status == 400 || subscribe?.data?.status == 401 || subscribe?.data?.status == 409 || subscribe?.data?.success === false) {
            setErrorMsg(subscribe?.data?.message);
            // setErrorFlag(true);
            showErrorToast(subscribe?.data?.message)
            setLoader(false);
        } else {
            setLoader(false);
        }
    }, [subscribe])

    return (<>
        <LatestNewsFormWrapper className="latest-news-in-container">
            <LatestNewsTitle>
                <Image src={Latest_news_icon} alt="latest_news_icon" width="30" height="30" />
                {MESSAGE.getOurLatestNews}
            </LatestNewsTitle>
            <Form onSubmit={formik.handleSubmit}>
                <FormGroupWrapper className="form-flex">
                    <FormInputGroup className="form-input-group">
                        <InputGroup className="input-group">
                            <FormGroup className="input-form-group" id="email">
                                <FormControl type="email" placeholder="Enter Email" id="email" value={formik.values.email} onChange={formik.handleChange} />
                                {formik.touched.email && formik.errors.email && (
                                    <div className="error">
                                        <p>{formik.errors.email}</p>
                                    </div>
                                )}
                            </FormGroup>
                            <FormGroup className="input-form-group">
                                <FormControl type="number" placeholder="Zip Code"
                                    onKeyDown={(evt) => ["e", "E", "+", "-", "."].includes(evt.key) && evt.preventDefault()}
                                    onInput={handleChange}
                                    name="zipcode"
                                    min="1"
                                    max="9999999"
                                    value={formik.values.zipcode}
                                    onChange={formik.handleChange}
                                />
                                {formik.touched.zipcode && formik.errors.zipcode && (
                                    <div className="error">

                                        <p>{formik.errors.zipcode}</p>
                                    </div>
                                )}
                            </FormGroup>
                        </InputGroup>
                        <InputGroup className="input-group-checkbox">
                            <FormGroup className="form-group">

                                <Form.Check type="radio" id="individual" label="I am an individual" name="type" value="individual" checked={formik.values.type === "individual"} onChange={formik.handleChange} />
                            </FormGroup>
                            <FormGroup className="form-group">
                                <Form.Check type="radio" id="organization" label="We are an organization" name="type" value="organization" checked={formik.values.type === "organization"} onChange={formik.handleChange} />
                            </FormGroup>
                        </InputGroup>
                        {formik.touched.type && formik.errors.type && (
                            <div className="error">
                                <p>{formik.errors.type}</p>
                            </div>
                        )}
                    </FormInputGroup>
                    <Button
                        variant="primary"
                        type="submit"
                        className="btn-outline-success-blue form-btn"
                        disabled={loader}
                    >
                        {MESSAGE.submitBtn}
                        {loader && <span className="btnloader"></span>}
                    </Button>
                </FormGroupWrapper>

            </Form>
        </LatestNewsFormWrapper>

        <LatestNewSubmitModal EditLatestNewSubmitOpen={editLatestNewSubmitOpen} SetLatestNewSubmitOpen={setEditLatestNewSubmitOpen} />
        <ErrorModal errorMsg={errorMsg} errorFlag={errorFlag} setErrorFlag={setErrorFlag} />
    </>);
}
export default LatestNewsForm;